module.exports = __webpack_public_path__ + "media/src/images/partners/open_education-b2a7d5e76099d153458a565e19ffb055.jpg";